import Modal from 'flarum/components/Modal';
import LinkedFormFill from '../components/LinkedFormFill';

/* global m */

export default class DiscussionFormModal extends Modal {
    className() {
        return 'FormulaireModal FormulaireTheme Modal--large';
    }

    title() {
        return this.props.form.title();
    }

    content() {
        return m('.Modal-body', LinkedFormFill.component({
            form: this.props.form,
            linked: this.props.discussion,
        }));
    }

    onsubmit(event) {
        // Prevent the page refreshing when typing enter
        // TODO: submit the actual Formulaire form when doing that
        event.preventDefault();
    }
}
